import React from "react";
import styles from "./navbar-action.module.css";
import { MyIcons } from "../../icons/my-icons";

const NavbarAction = ({ name, icon, height = 24, width = 24, isExpanded, onPress }) => {
  return (
    <div className={`${styles.action} ${!isExpanded ? styles.centered : ""}`} onClick={(e) => onPress && onPress(e)} >
      <MyIcons
        name={icon}
        width={height}
        height={width}
        color="var(--dark-grey)"
      />
      {!!isExpanded && <span className={styles.actionText}>{name}</span>}
    </div>
  );
};

export default NavbarAction;
